import Splide from '@splidejs/splide';
import '../../styles/web-components/review-carousel.scss';
import { DESKTOP_WIDTH } from '../vue/constants/devices';
const STAR_SVG = `
<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
<g>
<path d="M12.4188 8.73535L9.991 0.735352L7.56319 8.73535H0L6.17444 13.1454L3.82655 20.7354L9.991 16.0454L16.1654 20.7354L13.8176 13.1454L19.982 8.73535H12.4188Z" fill="#EEBF18"/>
</g>
</svg>
`;
const defaultCarouselOptions = {
    mediaQuery: "min",
    perPage: 1,
    arrows: false,
    gap: '24px',
    autoplay: true,
    type: 'loop',
    classes: {
        pagination: 'splide__pagination review-carousel__pagination',
    },
    breakpoints: {
        [DESKTOP_WIDTH]: {
            arrows: true,
        }
    }
};
class ReviewCarousel extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        let reviews = [];
        const reviewString = this.getAttribute('reviews');
        if (reviewString) {
            reviews = JSON.parse(reviewString);
        }
        else {
            // otherwise we'll use the attributes
            reviews = [1, 2, 3, 4, 5].map(i => {
                const quote = this.getAttribute(`review-${i}-quote`);
                const author = this.getAttribute(`review-${i}-author`);
                if (quote && author) {
                    return {
                        quote,
                        author
                    };
                }
                return null;
            }).filter(Boolean);
        }
        if (reviews.length === 0) {
            console.error("No reviews found");
            return;
        }
        this.render(reviews);
    }
    render(reviews) {
        const reviewsEls = reviews.map(review => `
        <li class="splide__slide review-carousel__slide">
          <div class="review-carousel-card__star-rating">
            ${[1, 2, 3, 4, 5].map(() => STAR_SVG).join('') /** we're currently only showing 5 stars for all reviews */}
          </div>
          <p class="review-carousel-card__quote">“${review.quote}”</p>
          <p class="review-carousel-card__author">– ${review.author}</p>
        </li>
      `).join('');
        this.innerHTML = `
      <div class="review-carousel__container">
        <div class="splide review-carousel__slider">
          <div class="splide__track">
            <ul class="splide__list">${reviewsEls}</ul>
          </div>
        </div>
      </div>
    `;
        const carousel = new Splide(this.querySelector('.splide'), defaultCarouselOptions);
        carousel.mount();
    }
}
if (!window.customElements.get("review-carousel")) {
    customElements.define("review-carousel", ReviewCarousel);
}
